import React from 'react';
import './icontext.css'

const Icontext = (props) => {
    return ( 
        <article className='container-icon-text'>
            <figure className='icon-cont'>
                    <img src={props.imgg} alt='icon'></img>
            </figure>

            <article className='text-part-icon-cont'>
                <h2 className='title-icon'>{props.title}</h2>
                <h3 className='para-icon'>{props.para}</h3>
            </article>
        </article>
     );
}
 
export default Icontext;